import {
	CardHeader,
	CardTitle,
	CardContent,
	Button,
} from "@/components/primitives";
import { ArrowRight, AlertTriangle } from "lucide-react";

interface ContributingFactorsIntroStepProps {
	/**
	 * Callback when user clicks "Next"
	 */
	onContinue: () => void;
}

export function ContributingFactorsIntroStep({
	onContinue,
}: ContributingFactorsIntroStepProps) {
	return (
		<>
			<CardHeader className="pb-4 border-b bg-gradient-to-r from-blue-50/50 to-indigo-50/50 dark:from-blue-950/20 dark:to-indigo-950/20">
				<div className="flex items-center gap-3">
					<div className="p-2 rounded-lg bg-gradient-to-br from-red-500 to-orange-600">
						<AlertTriangle className="h-5 w-5 text-white" />
					</div>
					<div>
						<CardTitle className="text-xl sm:text-2xl font-semibold">
							Contributing Factors
						</CardTitle>
					</div>
				</div>
			</CardHeader>
			<CardContent className="pt-6">
				<div className="space-y-6">
					<p className="text-muted-foreground leading-relaxed">
						Based on your reflections, we'll present a range of potential
						contributing factors for you to consider.
					</p>
					<p className="text-muted-foreground leading-relaxed">
						A 'contributing factor' is anything that plays a role in causing or
						increasing your stress, making it more intense or more likely to
						occur.
					</p>
					<div className="text-center pt-2">
						<Button
							onClick={onContinue}
							size="lg"
							className="bg-gradient-to-r from-blue-500 to-indigo-600 hover:from-blue-600 hover:to-indigo-700 text-white shadow-md hover:shadow-lg transition-all"
						>
							Next
							<ArrowRight className="h-4 w-4 ml-2" />
						</Button>
					</div>
				</div>
			</CardContent>
		</>
	);
}
